import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Modal} from 'reactstrap';
import {I18n} from 'react-redux-i18n';

import {isChangePasswordOpen} from '../selectors';
import {hideChangePasswordModal} from '../actions';

import customer from '../../customer';
const {savePasswordChange} = customer.actions;

class ChangePasswordModal extends React.Component
{
  constructor(props)
  {
    super(props);

    this.state = {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      passwordError: ''
    };
  }

  handlePasswordClose = () => {
    this.setState({oldPassword: ''});
    this.setState({newPassword: ''});
    this.setState({confirmPassword: ''});
    this.setState({passwordError: ''});
    this.props.actions.hideChangePasswordModal();
  };

  handleOldPasswordChange = (password) => {
    this.setState({oldPassword: password});
  }

  handlePasswordChange = (password) => {
    this.setState({newPassword: password});
    if(password.length < 8)
    {
      let errorMsg = I18n.t('PASSWORD_CHARACTERS');
      this.setState({passwordError: errorMsg});
    } 
    else if(password !== this.state.confirmPassword)
    {
      let errorMsg = I18n.t('PASSWORDS_DO_NOT_MATCH');
      this.setState({passwordError: errorMsg});
    } 
    else {
      this.setState({passwordError: ''});
    }
  }

  handleConfirmPasswordChange = (password) => {
    this.setState({confirmPassword: password});
    if(this.state.newPassword.length < 8)
    {
      let errorMsg = I18n.t('PASSWORD_CHARACTERS');
      this.setState({passwordError: errorMsg});
    }
    else if(password !== this.state.newPassword)
    {
      let errorMsg = I18n.t('PASSWORDS_DO_NOT_MATCH');
      this.setState({passwordError: errorMsg});
    } else {
      this.setState({passwordError: ''});
    }
  }

  handlePasswordAccept = () => {
    if(this.state.newPassword.length < 8)
    {
      let errorMsg = I18n.t('PASSWORD_CHARACTERS');
      this.setState({passwordError: errorMsg});
    } 
    else if(this.state.newPassword !== this.state.confirmPassword)
    {
      let errorMsg = I18n.t('PASSWORDS_DO_NOT_MATCH');
      this.setState({passwordError: errorMsg});
    }
    else {
      return new Promise((resolve) => {
        this.props.actions.savePasswordChange(this.state.oldPassword, this.state.newPassword)
          .then(() => {
            resolve();
            this.props.actions.hideChangePasswordModal();
          })
          .catch(() => {
            this.setState({oldPassword: ''});
            this.setState({newPassword: ''});
            this.setState({confirmPassword: ''});
            this.setState({passwordError: 'Invalid password. Please try again.'});
          });
      });
    }
  }

  render()
  {
    const {isOpen} = this.props;

    let confirmRowStyle = 'row';
    let confirmInputStyle = 'form-control';
    if(this.state.passwordError !== '')
    {
      confirmRowStyle += ' has-danger';
      confirmInputStyle += ' form-control-danger'; 
    }

    return (
      <Modal isOpen={isOpen} toggle={this.handlePasswordClose} id="modalSelectStore">
        <div className="modal-header">
          <h4 className="modal-title" id="exampleModalLabel">{I18n.t('CHANGE_PASSWORD')}</h4>
          <button type="button" className="close" onClick={this.handlePasswordClose}>
            <span className="lnr lnr-cross" aria-hidden="true" />
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-sm-12">
              <input className="form-control" 
                      type="password" 
                      value={this.state.oldPassword} 
                      placeholder={I18n.t('CURRENT_PASSWORD')}
                      onChange={(e) => {this.handleOldPasswordChange(e.target.value);}}
                      autoComplete="off" />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <input className="form-control" 
                      type="password" 
                      value={this.state.newPassword} 
                      placeholder={I18n.t('NEW_PASSWORD')}
                      onChange={(e) => {this.handlePasswordChange(e.target.value);}}
                      autoComplete="off" />
            </div>
          </div>
          <div className={confirmRowStyle}>
            <div className="col-sm-12">
              <input className={confirmInputStyle} 
                      type="password" 
                      value={this.state.confirmPassword} 
                      placeholder={I18n.t('CONFIRM_PASSWORD')}
                      onChange={(e) => {this.handleConfirmPasswordChange(e.target.value);}}
                      autoComplete="off" />
              {this.state.passwordError !== '' && <div className="form-control-feedback">{this.state.passwordError}</div>}
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.handlePasswordClose}>{I18n.t('CANCEL')}</button>
            <button type="button" className="btn btn-primary" onClick={this.handlePasswordAccept}>{I18n.t('CHANGE_PASSWORD')}</button>
          </div>
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    isOpen: isChangePasswordOpen(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({hideChangePasswordModal, savePasswordChange}, dispatch)
  };
}

ChangePasswordModal.propTypes = {
  actions: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordModal);


/** WEBPACK FOOTER **
 ** ./src/modules/navbar/components/ChangePasswordModal.js
 **/